import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import CustomPagination from "../../common/custompagination";
import Sorting from "../../common/sorting";
import Loader from "../../common/loader";
import Breadcrums from "../../common/breadcrumbs";
import $ from "jquery";
import {
  SWAL_SETTINGS,
  showFilterlist,
} from "../../../../utils/Constants";
import {
  capitalizeFirstLetter,
  formateDateWithMonth,
  handleServerValidations,
  removeSpecialCharacter,
  TrimText,
} from "../../../../utils/commonfunction";
import StatusFilter from "../../common/statusFilter";
import CustomRangepicker from "../../common/rangepicker";
import { ChangeUserPassword, deleteUser, userList, userStatus } from "../../services/user.service";
import { useFormik } from "formik";
import { Button, Modal } from "rsuite";

const UserTable = () => {
  const { t } = useTranslation();
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [statsupdate, setStatusUpdate] = useState("false");
  const [featuredStatsupdate, setFeaturedStatusUpdate] = useState("false");
  const [datalength, setDataLength] = useState("");
  const [itemperpage] = useState(10);
  const [sorting, setSorting] = useState({});
  const [defaultSorting, setDefaultSorting] = useState(true);
  const [page, setPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [search, setSearch] = useState({});
  const [globalsearch, setGlobalSearch] = useState("");
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("User"), url: "" },
  ];
  const [resetdate, setResetDate] = useState(false);

// --- STATE FOR PASSWORD MODAL (only need visibility and current ID now) ---
  const [showPassModal, setShowPassModal] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  // --------------------------------------------------------------------------


  // --- FORMIK SETUP ---
  const formik = useFormik({
    initialValues: {
      new_password: '',
      confirm_new_password: ''
    },
    validate: (values) => {
      const errors = {};
      if (values.new_password.length < 6) {
        errors.new_password = t("Password must be at least 6 characters long");
      }
      if (values.new_password !== values.confirm_new_password) {
        errors.confirm_new_password = t("New password and confirm password do not match");
      }
      return errors;
    },
    onSubmit: (values, { setSubmitting, resetForm }) => {
      if (formik.errors.new_password || formik.errors.confirm_new_password) {
        setSubmitting(false);
        return Swal.fire({
            icon: "error",
            text: t("Please fix validation errors"),
            ...SWAL_SETTINGS,
        });
      }

      if (!currentUserId) {
        setSubmitting(false);
        return;
      }

      const formData = {
          o_id: currentUserId,
          new_password: values.new_password,
          confirm_new_password: values.confirm_new_password,
      };
      
      // API Call
      ChangeUserPassword(formData) 
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
            closePasswordModal();
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          console.log("Error changing password:", error);
          Swal.fire({
            icon: "error",
            text: t("An unexpected error occurred"),
            ...SWAL_SETTINGS,
          });
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  });
  // ----------------------


  // --- HANDLER FOR MODAL OPEN/CLOSE ---
  const openPasswordModal = (userId) => {
    setCurrentUserId(userId);
    formik.resetForm(); // Reset Formik state when opening the modal
    setShowPassModal(true);
  };

  const closePasswordModal = () => {
    setShowPassModal(false);
  };
  // ------------------------------------

  useEffect(() => {
    const getData = setTimeout(() => {
      if (search) {
        setLoader(true);
        const formData = new FormData();
        formData.append("page", params.pgno);
        formData.append("per_page", itemperpage);
        formData.append("sort", JSON.stringify(sorting));
        formData.append("search", JSON.stringify(search));
        formData.append("global_search", globalsearch);
        userList(formData)
          .then((data) => {
            setDataLength(data.data.total_records);
            setList(data && data.data && data.data.list && Array.isArray(data.data.list) ? data.data.list : []);

            setPage(data && data.data && data.data.page ? data.data.page : 1);
            setLoader(false);
          })
          .catch((error) => {
            console.log("error ====> ", error);
          });
      }
    }, 300);
    return () => clearTimeout(getData)
  }, [
    location,
    statsupdate,
    sorting,
    search,
    globalsearch,
    itemperpage,
    params.pgno,
  ]);

  const viewfunction = (row) => {
    navigate(
      `/admin/user-management/user/view/${row._id}`
    );
  };

  const ChangeStatus = (o_id, data) => {
    Swal.fire({
      customClass: "swal-wide",
      title: t(`Are you sure you want to ${data === 0 ? "deactivate" : "activate"} this User ?`),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes"),
    }).then((result) => {
      if (result.isConfirmed) {
        userStatus({o_id: o_id, status: data})
          .then((response) => {
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setStatusUpdate(!statsupdate);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("error===>");
          });
      }
    });
  };



  function Deletefunction(data) {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("you_not_be_able_to_revert_this"),
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: t("btn_cancel"),
      confirmButtonColor: "#403fad",
      cancelButtonColor: "#f1388b",
      confirmButtonText: t("btn_yes_delete"),
    }).then((result) => {
      if (result.isConfirmed) {
        deleteUser(data)
          .then((response) => {
            setStatusUpdate(!statsupdate);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });

            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            console.log("deleteError");
          });
      }
    });
  }

  // sorting function start
  const handleSort = (e, column) => {
    setDefaultSorting(false);
    let sort = { order: 0, column: column };
    if (e.target.classList.contains("assc")) {
      sort.order = -1;
    } else {
      sort.order = 1;
    }
    setSorting(sort);
  };
  // sorting end

  // search or filter function
  const prepareSearch = (key, value) => {
    let sr = { ...search };
    if (String(value).length > 0) {
      sr[key] = value;
    } else {
      delete sr[key];
    }
    setSearch(sr);
  };
 
  const resetFilter = (e) => {
    e.preventDefault();
    setGlobalSearch("");
    prepareSearch();
    setSearch({});
    setResetDate(!resetdate);
    $("#defaultstatus")[0].selectedIndex = 0;
  };


  const goToEdit = (row) => {
    navigate(
      `/admin/user-management/user/${params.pgno}/edit/${row._id}`
    );
  };


  const planName = (row) => {
    if (row && row.enrollment_details && row.enrollment_details.plan_name) {
      if (row.enrollment_details.days_in_expiry < 0) {
        return removeSpecialCharacter(`${capitalizeFirstLetter(row.enrollment_details.plan_name)}`) + `-Expired`;
      } else {
        return removeSpecialCharacter( capitalizeFirstLetter(row.enrollment_details.plan_name));
      }
    } else {
      return "None";
    }
  }

  const renewBtnShow = (row) => {
    return (
      row?.enrollment_details?.days_in_expiry && row?.enrollment_details?.days_in_expiry <= 5
    )
  }

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="animation_fade">
        <div className="card custom-card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h6 className="main-content-label">
                {t("Users")}
              </h6>
              <div className="d-flex align-items-center">
                <div className="form-group mb-0 me-3">
                  <div className="form-group mb-0 rangepicker_container filter_design">
                    <i className="fa fa-search calender_icon"></i>
                    <input
                      type="search"
                      className="form-control"
                      value={globalsearch}
                      placeholder={t("input_placeholder_search")}
                      onChange={(e) => {
                        setGlobalSearch(e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="me-3">
                  <CustomRangepicker
                    GetDateRange={(e) => {
                      prepareSearch("createdAt", e);
                    }}
                    resetdate={resetdate}
                  />
                </div>
                <div className="me-3">
                  <StatusFilter
                    data={showFilterlist}
                    prepareSearch={prepareSearch}
                  />
                </div>
                <button
                  type="reset"
                  value="Reset"
                  onClick={resetFilter}
                  className="btn btn-warning float-right mr-2"
                >
                  {t("btn_reset_filter")}
                </button>
                {/* <button
                  className="btn ripple btn-main-primary signbtn mr-2"
                  onClick={() =>
                    navigate(`/admin/user-management/user/add`)
                  }
                >
                  {t("Create New User")}
                </button> */}
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-bordered border-t0 key-buttons text-nowrap w-100">
                <thead>
                  <tr>
                    <th className="position-relative select_head">
                      <span>{t("list_heading_sno")}</span>
                    </th>
                    {/* <th style={{ width: "50px" }}>{t("list_heading_profile")}</th> */}

                    <th>
                      <div className="sorting_column">
                        <span>{t("label_name")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          column="name"
                        />
                      </div>
                    </th>
                    <th>{t("list_heading_email")}</th>

                    <th className="created_head">
                      <div className="sorting_column">
                        <span>{t("list_heading_created_date")}</span>
                        <Sorting
                          sort={sorting}
                          handleSort={handleSort}
                          defaultSorting={defaultSorting}
                          column="createdAt"
                        />
                      </div>
                    </th>
                    {/* <th>Created By</th>
                    <th>Updated By</th> */}
                    {/* <th className="status_head">{t("featured")}</th> */}
                    <th className="status_head">{t("list_heading_status")}</th>
                    <th className="action_head">{t("list_heading_action")}</th>
                  </tr>
                </thead>
                <tbody>
                  {loader ? (
                    <tr>
                      <td colSpan={14}>
                        <Loader />
                      </td>
                    </tr>
                  ) : (
                    <>
                      {list.length ? (
                        list.map((row, i) => {
                          return (
                              <tr key={i}>
                                  <td>{row ? (page - 1) * itemperpage + i + 1 : null}</td>

                                  {/* <td>
                                {row?.profile_image ? (
                                  <div className="row_image">
                                    <img
                                      className="rounded"
                                      alt="profile"
                                      src={row?.profile_image}
                                    />
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </td> */}
                                  <td>{row?.name ? <div className="d-flex">{row?.name ? row.name : "N/A"}</div> : <div className="d-flex">N/A</div>}</td>
                                  <td>{row?.email ? row.email : "N/A"}</td>
                                  <td>{row.createdAt ? formateDateWithMonth(row.createdAt) : "N/A"}</td>
                                  <td>
                                      {row.status === 1 ? (
                                          <button
                                              className="btn ripple btn-main-primary signbtn"
                                              onClick={() => {
                                                  ChangeStatus(row?._id, 0);
                                              }}
                                          >
                                              {t("btn_active")}
                                          </button>
                                      ) : (
                                          <button
                                              className="btn ripple btn-secondary"
                                              onClick={() => {
                                                  ChangeStatus(row?._id, 1);
                                              }}
                                          >
                                              {t("btn_inactive")}
                                          </button>
                                      )}
                                  </td>

                                  <td>
                                      <div className="d-flex">
                                          <button
                                              className="btn ripple btn-main-primary signbtn"
                                              onClick={() => {
                                                  viewfunction(row);
                                              }}
                                          >
                                              {t("btn_view")}
                                          </button>

                                          {/* <button
                                              className="btn ripple btn-success mlAction"
                                              onClick={() => {
                                                  goToEdit(row);
                                              }}
                                          >
                                              {t("btn_edit")}
                                          </button> */}
                                          <button
                                              className="btn ripple btn-secondary mlAction"
                                              onClick={() => {
                                                  Deletefunction(row?._id);
                                              }}
                                          >
                                              {t("btn_delete")}
                                          </button>
                                          {/* {row?.login_with === "email" && (
                                              <button
                                                  className="btn ripple btn-warning mlAction"
                                                  onClick={() => {
                                                      openPasswordModal(row._id); // Open modal with user ID
                                                  }}
                                              >
                                                  {t("Change Password")}
                                              </button>
                                          )} */}
                                      </div>
                                  </td>
                              </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={14} className="text-center">
                            {t("msg_no_records")}
                          </td>
                        </tr>
                      )}
                    </>
                  )}
                </tbody>
              </table>
            </div>
            <div
              className=""
              id="example1_info"
              role="status"
              aria-live="polite"
            >
              <b>
                {t("msg_total_records")} : {datalength ? datalength : "0"}
              </b>
            </div>
            {datalength && datalength > 0 ? (
              <CustomPagination
                datalength={datalength}
                itemperpage={itemperpage}
                currentPage={page}
                setPage={setPage}
                pageRoute={[
                  {
                    name: "User List",
                    path: "/admin/user-management/user/list",
                  },
                ]}
              />
            ) : (
              ""
            )}
          </div>
        </div>
      </div>

     {/* --- PASSWORD CHANGE MODAL (Formik integrated) --- */}
    
      <Modal
        backdrop="static"
        keyboard={false}
        open={showPassModal}
        onClose={closePasswordModal}
        size="sm" // optional: small modal
      >
        <Modal.Header>
          <Modal.Title>{t("Change Password")}</Modal.Title>
        </Modal.Header>

        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="form-group mb-3">
              <label htmlFor="new_password">{t("New Password")}</label>
              <input
                type="text"
                className={`form-control ${formik.touched.new_password && formik.errors.new_password ? 'is-invalid' : ''}`}
                id="new_password"
                name="new_password"
                value={formik.values.new_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                minLength={6}
              />
              {formik.touched.new_password && formik.errors.new_password ? (
                <div className="invalid-feedback">{formik.errors.new_password}</div>
              ) : null}
            </div>

            <div className="form-group mb-3">
              <label htmlFor="confirm_new_password">{t("Confirm New Password")}</label>
              <input
                type="text"
                className={`form-control ${formik.touched.confirm_new_password && formik.errors.confirm_new_password ? 'is-invalid' : ''}`}
                id="confirm_new_password"
                name="confirm_new_password"
                value={formik.values.confirm_new_password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                required
                minLength={6}
              />
              {formik.touched.confirm_new_password && formik.errors.confirm_new_password ? (
                <div className="invalid-feedback">{formik.errors.confirm_new_password}</div>
              ) : null}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              onClick={closePasswordModal}
              appearance="subtle"
              disabled={formik.isSubmitting}
            >
              {t("btn_cancel")}
            </Button>
            <Button
              type="submit"
              appearance="primary"
              disabled={formik.isSubmitting}
            >
              {formik.isSubmitting ? t("Loading...") : t("Save Changes")}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>        
    </>
  );
};

export default UserTable;
